import { AgGridReact } from 'ag-grid-react';
import type {
  ColDef,
  RowSelectionOptions,
  GridReadyEvent,
  RowClickedEvent,
  GetRowIdParams,
  Theme,
  RowSelectedEvent,
  SizeColumnsToFitGridStrategy,
  SizeColumnsToFitProvidedWidthStrategy,
  SizeColumnsToContentStrategy,
} from 'ag-grid-enterprise';
import type { IRow } from '../types/TableRows';

interface DataGridProps {
  rowData?: IRow[];
  colDefs: ColDef<IRow>[];
  defaultColDef: ColDef;
  rowSelection: RowSelectionOptions;
  onGridReady: (params: GridReadyEvent) => void;
  onSelectionChanged: () => void;
  onRowClicked: (event: RowClickedEvent<IRow> | RowSelectedEvent<IRow>) => void;
  getRowId: (params: GetRowIdParams) => string;
  autoSizeStrategy: SizeColumnsToFitGridStrategy | SizeColumnsToFitProvidedWidthStrategy | SizeColumnsToContentStrategy;
  theme: Theme;
}

const paginationPageSizeSelector = [10, 20, 50, 100];

const DataGrid = ({
  rowData,
  colDefs,
  defaultColDef,
  rowSelection,
  onGridReady,
  onSelectionChanged,
  onRowClicked,
  getRowId,
  autoSizeStrategy,
  theme,
}: DataGridProps) => (
  <div className="ag-theme-quartz absolute h-screen w-full overflow-hidden">
    <AgGridReact
      rowData={rowData}
      columnDefs={colDefs}
      defaultColDef={defaultColDef}
      pagination
      paginationPageSizeSelector={paginationPageSizeSelector}
      paginationPageSize={20}
      rowSelection={rowSelection}
      onGridReady={onGridReady}
      onSelectionChanged={onSelectionChanged}
      onRowClicked={onRowClicked}
      getRowId={getRowId}
      autoSizeStrategy={autoSizeStrategy}
      theme={theme}
    />
  </div>
);

export default DataGrid;
